import React, { useState } from 'react';
import PropTypes from 'prop-types';
import QuestionInfo from './QuestionInfo';
import __ from '../../helpers/translation';

const propTypes = {
  current: PropTypes.object.isRequired,
  onAnswer: PropTypes.func.isRequired
};

function QuestionSlider(props) {

    let min = 1;
    let max = 30;
    const [sliderValue, setSliderValue] = useState(props.current.answer ?  props.current.answer : min)

    return (
        <React.Fragment>
            <div className="range-container">
                <h3>{sliderValue}</h3>
                <span className="left">{min}</span>
                <span className="right">{max}</span>
                <input defaultValue={sliderValue} 
                    onChange={(e) => { e.stopPropagation(); e.preventDefault(); setSliderValue(e.target.value); return false; } } type="range" min={min} max={max} className="slider" id="myRange" />
            </div>
            <button onClick={() => props.onAnswer(sliderValue) } className="btn btn-light bs-toggle">
                { __('app.questions.slider_button_next') }
            </button>
            <QuestionInfo {... props} />
        </React.Fragment>
    );
  
}

QuestionSlider.propTypes = propTypes;

export default QuestionSlider;